var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("orders"),
      _vm._v(" "),
      _c("top-bar"),
      _vm._v(" "),
      _c("bubble"),
      _vm._v(" "),
      _c("beverages")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d87e7ea", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d87e7ea","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./src/app/app.html
// module id = 183
// module chunks = 0